import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { CollectionPaths } from '@models/collections';
import { LLCToken } from '@models/llc-token';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { Repo } from '@repos/repo.service';
import { UserProfileState } from '@state/user-profile';

@Injectable({
	providedIn: 'root',
})
export class LlcTokensService extends Repo<LLCToken, unknown> {
	@SelectSnapshot(UserProfileState.getCurrentBusinessId) businessId!: string;

	GetCollectionPath(): string {
		return CollectionPaths.business_tokens_llc_tokens(this.businessId);
	}

	constructor(private firestore: AngularFirestore) {
		super(firestore);
	}
}
